/* eslint-disable no-nested-ternary */
import { Icon, Table, Tooltip } from 'antd';
import classNames from 'classnames/bind';
import { getPropsFromUrl } from 'components/hoc';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { toTimezone } from 'utils/dateTimeUtils';
import Enums from 'utils/EnumsManager';
import { getStore } from 'utils/localStorage';
import processData from '../components/processData';
import { tryFetchRawDataById, tryGenerateReportById } from '../flow/actions';
import styles from '../index.less';

const cx = classNames.bind(styles);

const {
  REPORTS, DROPZONES, FieldTypes, WEBSOCKET
} = Enums;
const { LocalStorageKeys } = Enums;
const { User } = LocalStorageKeys;
const { TOTALROWKEY, GROUPROWKEY } = REPORTS.PREVIEW;
const { GROUPS, OTHERS, AGGREGATES } = DROPZONES;
const {
  DateOnly,
  DateTime,
  Email,
  LongText,
  Lookup,
  NumberInput,
  PickList,
  TextInput
} = FieldTypes;
const ACTION_TYPES = {
  GENERATE: 'generate',
  VIEW: 'view'
};
const { EVENTS } = WEBSOCKET;

const defaultProps = {};
const propTypes = {
  groups: PropTypes.array.isRequired,
  records: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  fieldsMetaData: PropTypes.array.isRequired
};

class RealTimeReport_Table extends Component {
  componentDidMount() {
    // if action == generate then try generate first, if action == view, try view first
    const { action, tryGenerateReportById, reportId } = this.props;
    const { GENERATE, VIEW } = ACTION_TYPES;
    // TODO: unfinished part.
    // if (action === GENERATE) {
    // } else if (action === VIEW) {
    // }

    this.initSocketEvent();
    tryGenerateReportById(reportId);
  }

  getGroupRenderer = (text, record, index, data) => {
    if (record[GROUPROWKEY]) {
      return {
        children: (
          <div className={cx('groupby-item')}>
            {data.map(item => this.groupByItem(text, record, item))}
          </div>
        ),
        props: {
          rowSpan: record.count + 1,
          className: cx('bgWhite'),
        }
      };
    } else if (record[TOTALROWKEY]) {
      return {
        children: (
          <Fragment>
            <FormattedMessage
              id="page.RealTimeReport_Table.table.grandTotal"
              tagName="p"
            />
            <FormattedMessage
              id="page.ReportPreview.summary.count"
              values={{
              val: record.count,
            }}
              tagName="p"
            />
          </Fragment>
        )
      };
    }
    // For lookup type field, the value is an Object, we need to extract proper display value
    // TODO: complex response json with multiple cases
    const key = Object.keys(text || {}).filter(k => k !== 'id')[0];
    if (key) {
      return {
        children: <span className="vHidden">{text[key]}</span>,
        props: {
          rowSpan: 0,
        }
      };
    }
    return {
      children: <span className="vHidden">{text}</span>,
      props: {
        rowSpan: 0,
      }
    };
  }

  // eslint-disable-next-line react/sort-comp
  groupByItem = (text, record, item) => {
    // If group column is date type, the name will be combined with field name and its type
    if (item.type) {
      return (
        <Fragment>
          <p>{`${this.getLabelByFieldName(item.field_name)}: `}
            { record[`${item.field_name}__${item.type}`] ? (record[`${item.field_name}__${item.type}`]) :
              (
                <div style={{ display: 'inline-block' }}>
                  -
                  <Tooltip
                    title={
                      <FormattedMessage id="page.RealTimeReport_Table.table.tipForNull" />
                    }
                    placement="right"
                  >
                    <Icon type="info-circle" className="ml-sm icon-thinner" />
                  </Tooltip>
                </div>
              )
            }
          </p>
          <FormattedMessage
            id="page.ReportPreview.summary.count"
            values={{
              val: record.count,
            }}
            tagName="p"
          />
        </Fragment>
      );
    }
    const cellData = this.renderCellData(text, record, item.field_name);

    return (
      <Fragment>
        <p>{this.getLabelByFieldName(item.field_name)}: {
              cellData && item && item.field_name ?
              (_.isObject(cellData[item.field_name]) && cellData[item.field_name].name ? cellData[item.field_name].name : cellData[item.field_name])
              : ''
            }
        </p>
        <FormattedMessage
          id="page.ReportPreview.summary.count"
          values={{
            val: record.count,
          }}
          tagName="p"
        />
      </Fragment>
    );
  }

  /**
   * @param {Array} data selected columns
   * @param {Number} i index of current column
   * @param {Object} colsCount counts of different types of columns
   * @param {Number} otherLength is about the length of other columns
   */
  getOtherRenderer = (data, i, colsCount) => ({
    key: data,
    dataIndex: data,
    title: this.getLabelByFieldName(data),
    render: (text, record) => {
      if (record[GROUPROWKEY] || record[TOTALROWKEY]) {
        // render nothing if the field has no sum and avg
        return {
          children: null,
          props: {
            // combine group and total parts of the other columns
            colSpan: i === 0 ? colsCount[OTHERS] : 0,
          }
        };
      }
      const cellData = this.renderCellData(text, record, data);
      return cellData && cellData.name ? cellData.name : cellData;
    }
  });
  getAggregateRenderer = (data, i, colsCount) => ({
    key: data.field_name,
    dataIndex: data.field_name,
    title: this.getLabelByFieldName(data.field_name),
    render: (text, record) => {
      if (record[GROUPROWKEY] || record[TOTALROWKEY]) {
        // render summary data and merge right cells to this one
        return this.renderSummaryData(record, data.field_name);
      }
      return text;
    }
  });
  getRenderers = () => {
    const { settings, fieldsMetaData } = this.props;
    const othersSetting = [];
    const aggregatesSetting = [];

    settings[OTHERS].forEach(other => {
      fieldsMetaData.forEach(meta => {
        if (!meta.fieldRestricted && other === meta.name) {
          othersSetting.push(other);
        }
      });
    });

    settings[AGGREGATES].forEach(aggre => {
      fieldsMetaData.forEach(meta => {
        if (!meta.fieldRestricted && aggre.field_name === meta.name) {
          aggregatesSetting.push(aggre);
        }
      });
    });

    const colsCount = {
      [GROUPS]: settings[GROUPS].length,
      [OTHERS]: othersSetting.length,
      [AGGREGATES]: aggregatesSetting.length
    };

    const groupRenderers = {
      title: 'Group by',
      render: (text, record, index) => this.getGroupRenderer(text, record, index, settings[GROUPS]),
    };
    const otherRenderers = othersSetting.map(
      (o, i) => this.getOtherRenderer(o, i, colsCount),
      this
    );
    const aggregateRenderers = aggregatesSetting.map(
      (a, i) => this.getAggregateRenderer(a, i, colsCount),
      this
    );
    return [groupRenderers, ...otherRenderers, ...aggregateRenderers];
  };
  getLabelByFieldName = name => {
    if (_.isEmpty(name)) {
      return '';
    }
    const { fieldsMetaData } = this.props;
    const field = fieldsMetaData.find(f => f.name === name);
    return field ? field.label : '';
  };
  initSocketEvent = () => {
    const { tryFetchRawDataById, reportId, location } = this.props;
    const me = this;

    const user = getStore(User);
    const parsedUser = JSON.parse(user);

    window.Echo.addPrivateChannel(
      parsedUser.id,
      EVENTS.GENERATE_REPORT,
      data => {
        if (_.isEmpty(data)) return;

        const { report_id } = data;
        if (_.isNil(report_id)) return;

        // fetch data when the id from socket as same as current report
        if (_.toNumber(reportId) === report_id && location.pathname.indexOf('generate') > -1) {
          tryFetchRawDataById(report_id);
        }
      }
    );
  };
  /**
   * @param {Object} record current row data
   * @param {Object} settings report column settings
   */
  renderSummaryData = (record, fieldName) => {
    const columns = _.isArray(this.props.settings[AGGREGATES])
      ? this.props.settings[AGGREGATES].find(col => col.field_name === fieldName)
      : [];

    return (
      <div className={cx('summary')}>
        {
          _.isArray(columns.functions) && columns.functions.map(f => {
            const key = `${fieldName}__${f}`;
            return (
              <FormattedMessage
                key={key}
                id={`page.RealTimeReport_Table.table.summary.${f}`}
                values={{
                  val: record[key] ? _.toNumber(record[key]).toFixed(2) : 'N/A'
                }}
              >
                {text => <div style={{ display: 'inline-block' }}>{text}</div>}
              </FormattedMessage>
            );
          })
        }
      </div>
    );
  };
  /**
   * @param {Any Primitive} cellVal value of current cell
   * @param {Object} rowVal record of row
   * @param {String} name id of the field
   */
  renderCellData = (cellVal, rowVal, name) => {
    const { fieldsMetaData } = this.props;
    const field = fieldsMetaData.find(f => f.name === name);

    if (!field || _.isEmpty(field.type)) {
      return null;
    }
    switch (field.type) {
      case DateOnly:
      case DateTime:
        return toTimezone(cellVal, field.type === DateTime);
      case Lookup:
      case Email:
      case LongText:
      case NumberInput:
      case PickList:
      case TextInput:
        return cellVal;
      default:
        return null;
    }
  };

  render() {
    const { processedData, generating } = this.props;
    return (
      <Table
        className={cx('reportTable')}
        dataSource={processedData}
        columns={this.getRenderers()}
        size="small"
        rowKey={(item, i) => i}
        pagination={false}
        rowClassName={record => {
          if (record[GROUPROWKEY]) {
            return cx('groupRow');
          } else if (record[TOTALROWKEY]) {
            return cx('totalRow');
          }
          return cx('row');
        }}
        bordered
        loading={generating}
      />
    );
  }
}

const mapStateToProps = ({ global, realTimeReport }) => {
  const { info, rawData } = realTimeReport;
  const { settings } = info;
  const {
    groups, records, generating, total
  } = rawData;
  return {
    lang: global.language,
    groups,
    total,
    records,
    settings,
    generating
  };
};
const mapDispatchToProps = {
  tryFetchRawDataById,
  tryGenerateReportById
};
RealTimeReport_Table.defaultProps = defaultProps;
RealTimeReport_Table.propTypes = propTypes;
const enhancers = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  getPropsFromUrl(['reportId', 'action']),
  processData()
);
export default enhancers(RealTimeReport_Table);



// WEBPACK FOOTER //
// ./src/views/RealTimeReport_Table/container/index.jsx